<template>
  <div>
    <table class="table table-hover table-sm">
      <tr v-for="(user, id, index) in users">
        <td width="50px">{{ (index === undefined ? id : index) + 1 }}</td>
        <td>
          <div>
            <button
              v-if="editUser"
              @click="editUser(user)"
              class="btn btn-xs btn-info pull-left mr-2"
            >
              <i class="icon-fa icon-fa-eye"></i>
            </button>
            <UserInfo :user="user"/>
          </div>
        </td>
        <td>
          <p v-for="role in user.roles">{{ role.name_title }}</p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

import UserInfo from "@/views/users/components/UserInfo";

export default {
  components: {
    UserInfo,
  },
  props: [
    'users', 'editUser'
  ],
  data() {
    return {}
  },
  methods: {}
}

</script>

<style scoped>
p {
  margin-bottom: 2px;
}
</style>
